/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResellerMasterdata } from '../../models/reseller-masterdata';

export interface GetReseller$Params {
  resellerId: string;
}

export function getReseller(http: HttpClient, rootUrl: string, params: GetReseller$Params, context?: HttpContext): Observable<StrictHttpResponse<ResellerMasterdata>> {
  const rb = new RequestBuilder(rootUrl, getReseller.PATH, 'get');
  if (params) {
    rb.path('resellerId', params.resellerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResellerMasterdata>;
    })
  );
}

getReseller.PATH = '/resellers/{resellerId}';
